import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const tiers = [{
  name: 'Signal',
  price: '490',
  description: 'Essential growth infrastructure for emerging channels.',
  features: ['Comprehensive Channel Audit', '90-Day Growth Roadmap', 'Monthly Strategy Call', 'Basic Analytics Dashboard', 'Email Support'],
  highlighted: false
}, {
  name: 'Broadcast',
  price: '1,290',
  description: 'Full monetization and brand deal brokering.',
  features: ['Everything in Signal', 'Brand Deal Brokering', 'Revenue Architecture Design', 'Weekly Strategy Calls', 'Priority Discord Support', 'Custom Rate Card Creation'],
  highlighted: true
}, {
  name: 'Primetime',
  price: '2,890',
  description: 'Dedicated management for top-tier creators.',
  features: ['Everything in Broadcast', 'Dedicated Growth Manager', 'Custom Analytics Suite', 'Unlimited Consultations', 'Event & Launch Strategy', 'Merch Line Development'],
  highlighted: false
}];
export function Pricing() {
  return <section id="pricing" className="py-24 relative z-10 bg-studio-900" data-id="element-103">
      <div className="max-w-7xl mx-auto px-6" data-id="element-104">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-105">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-106">
            Transmission Plans
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-107">
            Select the level of support your channel needs to reach the next
            tier.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center" data-id="element-108">
          {tiers.map((tier, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`relative rounded-2xl p-8 ${tier.highlighted ? 'glass-panel border-stream-500 shadow-[0_0_30px_rgba(168,85,247,0.15)] md:-translate-y-4' : 'bg-studio-800 border border-white/5'}`} data-id="element-109">
              {tier.highlighted && <div className="absolute -top-4 left-1/2 -translate-x-1/2 px-3 py-1 bg-stream-600 text-white text-xs font-bold rounded-full uppercase tracking-wider" data-id="element-110">
                  Popular
                </div>}

              <div className="mb-8" data-id="element-111">
                <h3 className="text-xl font-semibold text-white mb-2" data-id="element-112">
                  {tier.name}
                </h3>
                <p className="text-sm text-gray-400 h-10" data-id="element-113">{tier.description}</p>
              </div>

              <div className="mb-8 flex items-baseline gap-1" data-id="element-114">
                <span className="text-2xl text-gray-400" data-id="element-115">€</span>
                <span className="text-5xl font-mono font-bold text-white" data-id="element-116">
                  {tier.price}
                </span>
                <span className="text-gray-400" data-id="element-117">/mo</span>
              </div>

              <ul className="space-y-4 mb-8" data-id="element-118">
                {tier.features.map((feature, fIndex) => <li key={fIndex} className="flex items-start gap-3" data-id="element-119">
                    <CheckIcon className={`w-5 h-5 shrink-0 ${tier.highlighted ? 'text-stream-400' : 'text-gray-500'}`} data-id="element-120" />
                    <span className="text-sm text-gray-300" data-id="element-121">{feature}</span>
                  </li>)}
              </ul>

              <button className={`w-full py-3 rounded-lg font-semibold transition-all ${tier.highlighted ? 'bg-stream-600 hover:bg-stream-500 text-white' : 'bg-white/5 hover:bg-white/10 text-white border border-white/10'}`} data-id="element-122">
                Select {tier.name}
              </button>
            </motion.div>)}
        </div>
      </div>
    </section>;
}